// ConnectPage.js
import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Box,
  CircularProgress,
  Tooltip,
  List,
  ListItem,
  ListItemText,
  Divider,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControlLabel,
  Switch,
  Select,
  FormControl,
  InputLabel
} from "@mui/material";
import {
  ChevronLeft,
  ChevronRight,
  AccountCircle,
  ExpandMore,
  ArrowBack
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import GroupIcon from "@mui/icons-material/Group";
import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import AddLinkIcon from "@mui/icons-material/AddLink";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CryptoJS from "crypto-js";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import QueueIcon from "@mui/icons-material/Queue";
import QueueMusicIcon from "@mui/icons-material/QueueMusic";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import PhoneNumberPage from "../phoneNumber/displaynumber";
import QuickConnectPage from "../QuickConnects/quickConnect";
import SecurityProfilesPage from "../SecurityProfiles/viewprofiles";
import RoutingProfielPage from "../routingProfile/routedisplay";
import QueuesPage from "../queues/displayqueues";
import LogsPage from "../logsDashBoard/logs";
import { axiosInstance } from "../../services/axiosInstance";
import { endpoints } from "../../services/endpoint";
import CCBNavBarLogo from "../../assets/CCBNavBarLogo.webp";
import CCBAppBarLogo from "../../assets/Nav Bar.png";
import CCBNavlogo from "../../assets/favicon-cc.ico";
import "./connect.css";
import "../AwsAccountsListPage/InstanceList.css";
import PromptsPage from "../prompts/promptsdisplay";
import AddProfilePage from "../addSecurityProfile/addProfile";
import HoursOperationPage from "../hoursOperation/displayhours";
import UserPage from "../users/userdisplay";
import EmergencyPage from "../emergencyClose/emergency";
import HolidayPage from "../Holidaylist/holiday";
import VoicemailPage from "../VoiceMail/voiceMail";

const ConnectPage = () => {
  const [loading, setLoading] = useState(false);
  const [loadingButtonId, setLoadingButtonId] = useState(null);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [selectedComponentData, setSelectedComponentData] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showProfileDetails, setShowProfileDetails] = useState(false);

  // ── Parse the single source of truth stored by AwsAccountsListPage ──────────
  const listInstancesRaw = localStorage.getItem("ListInstancesResponse");
  const listInstancesData = listInstancesRaw ? JSON.parse(listInstancesRaw) : {};
  const instances = listInstancesData.instances || [];
  const customerAWSAccountId = listInstancesData.awsAccount || "";

  // ── Selected instance ─────────────────────────────────────────────────────
  // Priority: 1) SelectedInstance key set by InstanceListPage on row click
  //           2) Auto-select when exactly one instance exists
  const getInitialInstance = () => {
    const stored = localStorage.getItem("SelectedInstance");
    if (stored) {
      try { return JSON.parse(stored); } catch (_) { }
    }
    return instances.length === 1 ? instances[0] : null;
  };
  const [selectedInstance, setSelectedInstance] = useState(getInitialInstance);
  const [region, setRegion] = useState("");
  const [instanceAlias, setInstanceAlias] = useState("");
  const [EncryptedInstanceId, setEncryptedInstanceId] = useState("");
  const [instanceId, setInstanceId] = useState("");

  useEffect(() => {
    if (!selectedInstance) return;

    setRegion(selectedInstance.Region || "");
    setInstanceAlias(selectedInstance.InstanceAlias || "");
    setEncryptedInstanceId(selectedInstance.EncryptedInstanceId || "");
    setInstanceId(selectedInstance.InstanceId || "");

  }, [selectedInstance]);

  // Other user info from auth
  const username = localStorage.getItem("username");
  const email = localStorage.getItem("Email");

  const navigate = useNavigate();
  const SECRET_KEY = "YourSharedSecretKey123!";
  const encryptedId = instanceId ? btoa(instanceId) : "";


  // All your existing fetch functions remain the same...
  const fetchPhoneNumbers = async () => {
    const payload = {
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region,
      InstanceAlias: instanceAlias,
      Action: "list"
    };
    const res = await axiosInstance.post(endpoints.displayPhoneNumberlist.phoneNumber, payload);
    const data = res.data?.body ? JSON.parse(res.data.body) : [];
    setSelectedComponent("PhoneNumberPage");
    setSelectedComponentData(data);
  };
  const fetchQuickConnects = async () => {
    const payload = {
      Action: "list",
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region,
      InstanceAlias: instanceAlias,
    };

    try {
      const res = await axiosInstance.post(
        endpoints.displayquickConnects.quickConnects,
        payload
      );

      const rawBody = res?.data?.body;
      if (!rawBody) {
        console.warn("QuickConnects: response body is undefined or empty");
        setSelectedComponentData([]);
        return;
      }

      let parsed;
      try {
        parsed = JSON.parse(rawBody);
      } catch (err) {
        console.error("Failed to parse QuickConnects JSON:", err);
        setSelectedComponentData([]);
        return;
      }

      const dataArray = Array.isArray(parsed) ? parsed : parsed.quickConnects || [];

      const data = dataArray.map((item) => ({
        quickConnectARN: item.QuickConnectARN,
        quickConnectId: item.QuickConnectId,
        name: item.Name,
        description: item.Description || "",
        quickConnectType: item.QuickConnectConfig?.QuickConnectType || "",
        queueId: item.QuickConnectConfig?.QueueConfig?.QueueId || "",
        contactFlowId:
          item.QuickConnectConfig?.QueueConfig?.ContactFlowId ||
          item.QuickConnectConfig?.UserConfig?.ContactFlowId ||
          "",
        userId: item.QuickConnectConfig?.UserConfig?.UserId || "",
        phoneNumber: item.QuickConnectConfig?.PhoneConfig?.PhoneNumber || "",
        tags: item.Tags || {},
        lastModifiedTime: item.LastModifiedTime,
        lastModifiedRegion: item.LastModifiedRegion,
        queueName: item.QueueName || "",
        userName: item.UserName || "",
        contactFlowName: item.ContactFlowName || "",
      }));

      setSelectedComponent("QuickConnectPage");
      setSelectedComponentData(data);
    } catch (error) {
      console.error("Error fetching quick connects:", error);
      setSelectedComponentData([]);
    }
  };

  const fetchSecurityProfiles = async () => {
    const payload = {
      action: "listsecurityprofiles",
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region,
      InstanceAlias: instanceAlias,
    };

    const res = await axiosInstance.post(endpoints.displaysecurityprofile.securityprofile, payload);

    let parsed = {};
    try {
      const rawBody = res.data?.body || "{}";
      parsed = JSON.parse(rawBody);
    } catch (error) {
      console.error("Error parsing response body:", error);
      setSelectedComponentData([]);
      return;
    }
    // Safely access securityProfiles array
    const securityProfilesArray = Array.isArray(parsed.securityProfiles) ? parsed.securityProfiles : [];

    const data = securityProfilesArray.map(item => ({
      securityProfileARN: item.Arn,
      securityProfileId: item.Id,
      name: item.SecurityProfileName,
      description: item.Description || '',
      permissions: item.Permissions || [],
      tags: item.Tags || {},
      allowedAccessControlTags: item.AllowedAccessControlTags || {},
      lastModifiedTime: item.LastModifiedTime || '',
      instanceId: item.InstanceId || '',
    }));

    setSelectedComponent("SecurityProfilesPage");
    setSelectedComponentData(data);
  };
  const fetchLogs = async () => {
    try {
      const payload = { instanceAlias };

      const res = await axiosInstance.post(
        endpoints.adminLogs.logsDashboard,
        payload
      );

      const parsedBody = res.data?.body ? JSON.parse(res.data.body) : {};
      const logsArray = parsedBody.items || [];

      setSelectedComponent("LogsPage");
      setSelectedComponentData(logsArray);

    } catch (error) {
      console.error("Error fetching logs:", error);
      setSelectedComponentData([]);
    }
  };

  const fetchHoursOfOperation = async () => {
    const payload = {
      InstanceAlias: instanceAlias,
      awsAccount: customerAWSAccountId,
      region,
      ID: EncryptedInstanceId,
    };

    try {
      const response = await axiosInstance.post(
        endpoints.displaylisthop.dipslayhopdata,
        payload
      );

      console.log("API Raw Response:", response.data);

      // ✅ Parse body safely
      const parsedBody =
        typeof response.data.body === "string"
          ? JSON.parse(response.data.body)
          : response.data.body;

      if (Array.isArray(parsedBody)) {
        const extractedData = parsedBody.map((item, index) => {
          const configData = item.Config || [];

          // ✅ Store config per HOP
          localStorage.setItem(
            `customHoursConfig_${item.Arn}`,
            JSON.stringify(configData)
          );

          // ✅ Normalize tags
          let tagsArray = [];
          if (item.Tags && item.Tags !== "-" && typeof item.Tags === "string") {
            tagsArray = item.Tags.split(",").map(tag => {
              const [key, value] = tag.split(":").map(s => s.trim());
              return { key, value };
            });
          }
          return {
            id: item.Arn,
            name: item.Name,
            description: item.Description || "No description",
            tags: tagsArray,
            timeZone: item.TimeZone,
            config: configData,
            lastModifiedTime: item.LastModifiedTime,
          };
        });

        console.log("✅ Extracted Hours Data:", extractedData);

        setSelectedComponent("HoursOperationPage");
        setSelectedComponentData(extractedData);
      } else {
        console.warn("⚠️ Body is not an array");
      }
    } catch (error) {
      console.error("❌ Error fetching hours of operation:", error);
    }
  };

  const fetchQueues = async () => {
    const body = {
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region,
      InstanceAlias: instanceAlias,
      Email: email,
      UserName: username,
    };

    try {
      const response = await axiosInstance.post(
        endpoints.queuesDisplay.viewQueues,
        body
      );

      console.log("Full API Response:", response);

      if (response?.data?.statusCode !== 200) {
        console.error("Failed to fetch queues:", response?.data?.message);
        return;
      }

      // ✅ Parse stringified body safely
      const parsedBody = JSON.parse(response.data.body);

      // ✅ Extract correct array
      const queues =
        parsedBody?.queues?.DescribedQueues &&
          Array.isArray(parsedBody.queues.DescribedQueues)
          ? parsedBody.queues.DescribedQueues
          : [];

      console.log("Parsed Queues Array:", queues);

      if (queues.length === 0) {
        console.warn("No queues found");
        setSelectedComponent("QueuesPage");
        setSelectedComponentData([]);
        return;
      }

      // ✅ Transform API data → UI-friendly format
      const extractedData = queues.map((item) => {
        const quickConnectNames =
          item.QuickConnects && item.QuickConnects.length > 0
            ? item.QuickConnects.map(
              (qc) => qc.QuickConnectName
            ).join(", ")
            : "No QuickConnects";

        const tags =
          item.Tags && Object.keys(item.Tags).length > 0
            ? Object.entries(item.Tags)
              .map(([key, value]) => `${key}: ${value}`)
              .join(", ")
            : "No tags";

        return {
          id: item.QueueId,
          name: item.Name || "Unnamed Queue",
          description: item.Description || "No description",
          hoursOfOperation: item.HoursOfOperationName || "No hours set",
          quickConnects: quickConnectNames,
          maxContacts: item.MaxContacts ?? "-",
          outboundCallerIdName:
            item.OutboundCallerConfig?.OutboundCallerIdName || "-",
          outboundCallerIdNumber:
            item.OutboundCallerConfig?.OutboundCallerIdNumberId || "-",
          outboundFlowId:
            item.OutboundCallerConfig?.OutboundFlowId || "-",
          outboundFlowName: item.OutboundFlowName || "-",
          outboundCallerIdNumberValue:
            item.OutboundCallerIdNumber || "-",
          status: item.Status || "-",
          tags,
          lastModifiedTime: item.LastModifiedTime || "-",
          lastModifiedRegion: item.LastModifiedRegion || "-",
        };
      });
      setSelectedComponent("QueuesPage");
      setSelectedComponentData(extractedData);

    } catch (error) {
      console.error("Error fetching queues:", error);
    }
  };

  const fetchPrompts = async () => {
    const body = {
      action: "list",
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region: region,
      InstanceAlias: instanceAlias,
    };

    try {
      const response = await axiosInstance.post(
        endpoints.promptsDisplay.promptlist,
        body
      );

      console.log("Prompts API Response:", response);

      if (response.data.statusCode === 200) {
        const parsedBody = JSON.parse(response.data.body);
        const promptList = parsedBody.prompts;

        if (Array.isArray(promptList)) {
          const formattedPrompts = promptList.map((item) => ({
            name: item.Name || "Unnamed Prompt",
            id: item.Id || "-",
            arn: item.ARN || "-",
            description: item.Description || "No description",
            tags: item.Tags && Object.keys(item.Tags).length > 0 ? item.Tags : {},
          }));

          console.log("✅ Extracted Prompts (clean):", formattedPrompts);
          const sortedPrompts = formattedPrompts.sort((a, b) =>
            a.name.localeCompare(b.name)
          );

          setSelectedComponent("PromptsPage");
          setSelectedComponentData(sortedPrompts);
        } else {
          console.warn("⚠️ `prompts` is not an array:", promptList);
        }
      } else {
        console.warn(
          "⚠️ API returned non-200 statusCode:",
          response.data.statusCode
        );
      }
    } catch (error) {
      console.error("❌ Error fetching prompts:", error);
    }
  };
  const fetchRoutingProfile = async () => {
    const payload = {

      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region: region,
    };

    try {
      const response = await axiosInstance.post(endpoints.displayroutes.viewroutes, payload);
      console.log("Routing Profile Response Data:", response.data);

      if (response.data && Array.isArray(response.data)) {
        const extractedData = response.data.map((item) => {
          // 🟦 Associated Queues
          const associatedQueues = item.AssociatedQueues?.map((queue) => {
            return `${queue.QueueName} (Priority: ${queue.Priority}, Delay: ${queue.Delay}, Channel: ${queue.Channel})`;
          }).join(" | ") || "No Associated Queues";

          // 🟦 Media Concurrencies
          const mediaConcurrencies = item.MediaConcurrencies?.map((media) => ({
            channel: media.Channel,
            concurrency: media.Concurrency,
            behavior: media.CrossChannelBehavior,
            checked: media.Channel === "VOICE", // VOICE checked by default
          })) || [];

          const mediaConcurrenciesDisplay = mediaConcurrencies.map(
            (media) =>
              `${media.channel} (Concurrency: ${media.concurrency}, Behavior: ${media.behavior})`
          ).join(" | ") || "No Media Channels";

          // 🟦 Tags formatting: "Department:Sales, Region:West"
          let tags = "No tags";
          if (item.Tags) {
            let tagObj = null;

            if (typeof item.Tags === "object" && !Array.isArray(item.Tags)) {
              tagObj = item.Tags;
            } else if (typeof item.Tags === "string") {
              try {
                const parsed = JSON.parse(item.Tags);
                if (typeof parsed === "object" && !Array.isArray(parsed)) {
                  tagObj = parsed;
                }
              } catch (e) {
                console.warn("Failed to parse Tags string:", item.Tags);
              }
            }

            if (tagObj) {
              tags = Object.entries(tagObj)
                .map(([key, value]) => `${key}:${value}`)
                .join(", ");
            }
          }
          return {
            name: item.Name,
            description: item.Description || "No description",
            tags: item.Tags,
            agentAvailabilityTimer: item.AgentAvailabilityTimer || "-",
            defaultOutboundQueueName: item.DefaultOutboundQueueName || "-",
            numberOfAssociatedQueues: item.NumberOfAssociatedQueues || 0,
            numberOfAssociatedUsers: item.NumberOfAssociatedUsers || 0,
            associatedQueues,
            mediaConcurrenciesDisplay,
            mediaConcurrencies,
          };
        });

        console.log("✅ Extracted Routing Profiles:", extractedData);

        setSelectedComponent("RoutingPage");
        setSelectedComponentData(extractedData);
      } else {
        console.warn("No routing profile data found!");
      }
    } catch (error) {
      console.error("❌ Error fetching routing profiles:", error);
    }
  };

  const fetchUsers = async () => {
    const payload = {
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region: region,
      InstanceAlias: instanceAlias,
      UserName: username,
      Email: email,
    };

    try {
      const response = await axiosInstance.post(
        endpoints.userList.listusers,
        payload
      );

      console.log("Response Data:", response.data);

      // ✅ FIX 1: check statusCode
      if (response.data?.statusCode === 200 && Array.isArray(response.data.body)) {

        // ✅ FIX 2: map from response.data.body
        const extractedData = response.data.body.map((item) => ({
          Login: item.Login,
          FullName: item.FullName,
          RoutingProfile: item.RoutingProfile,
          ACWTimeout: item.ACWTimeout,
          FirstName: item.FirstName,
          LastName: item.LastName,
          Email: item.Email,
          SecondaryEmail: item.SecondaryEmail,
          ARN: item.ARN,
          AutoAccept: item.AutoAccept,
          DeskPhone: item.DeskPhone,
          PhoneType: item.PhoneType,
          SecurityProfiles: item.SecurityProfiles,
          Tags: item.Tags,
        }));

        console.log("Extracted User Data:", extractedData);
        setSelectedComponent("UserPage");
        setSelectedComponentData(extractedData);

      } else {
        console.warn("Invalid response structure from API", response.data);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const fetchQueueslist = async () => {
    const body = {
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region: region,
      InstanceAlias: instanceAlias,
      Email: email,
      UserName: username,
    };

    try {
      const [queueResponse, emergencyResponse] = await Promise.all([
        axiosInstance.post(endpoints.queuesDisplay.viewQueues, body),
        axiosInstance.get(endpoints.globalEnable.emergencyCloseStatus),
      ]);

      if (queueResponse.data.statusCode === 200) {
        const data = JSON.parse(queueResponse.data.body);

        // ✅ Extract emergency data
        const emergencyData = emergencyResponse.data?.data || [];

        // ✅ Create map (normalize names)
        const emergencyMap = {};
        emergencyData.forEach((item) => {
          const key = item.Queue?.trim().toLowerCase().replace(/\s+/g, "");
          emergencyMap[key] = item.EmergencyStatus;
        });

        if (data.queues && Array.isArray(data.queues.DescribedQueues)) {
          const extractedData = data.queues.DescribedQueues.map((item) => {
            const quickConnectNames =
              item.QuickConnects && Array.isArray(item.QuickConnects)
                ? item.QuickConnects.map((qc) => qc.QuickConnectName).join(", ")
                : "No QuickConnects";

            const tags = item.Tags
              ? Object.entries(item.Tags)
                .map(([key, value]) => `${key}: ${value}`)
                .join(", ")
              : "No tags";

            const normalizedName = item.Name
              ?.trim()
              .toLowerCase()
              .replace(/\s+/g, "");

            console.log(
              "Queue:",
              item.Name,
              "Emergency Status:",
              emergencyMap[normalizedName]
            );

            return {
              name: item.Name,
              description: item.Description || "No description",
              HoursOfOperationName:
                item.HoursOfOperationName || "No hours set",
              QuickConnectName: quickConnectNames,
              maxContacts: item.MaxContacts || "-",
              status: item.Status || "UNKNOWN",
              emergencyStatus:
                emergencyMap[normalizedName] !== undefined
                  ? emergencyMap[normalizedName]
                  : false,

              tags,
              arn: item.QueueArn,
              timeZone: item.TimeZone || "No timezone",
              config: item.Config || {},
              lastModifiedTime:
                item.LastModifiedTime || "No modification time",
              outboundCallerIdName:
                item.OutboundCallerConfig?.OutboundCallerIdName || "-",
              outboundCallerIdNumber:
                item.OutboundCallerIdNumber || "-",
              outboundFlowName: item.OutboundFlowName || "-",
              quickConnectTypes: item.QuickConnects
                ? item.QuickConnects.map((qc) => qc.QuickConnectType)
                : ["No Quick Connects"],
            };
          });

          console.log("Final Emergency Data:", extractedData);
          setSelectedComponent("EmergencyPage");
          setSelectedComponentData(extractedData);
        } else {
          console.warn("No DescribedQueues found in response");
        }
      } else {
        console.error("Failed to fetch queues:", queueResponse.data.message);
      }
    } catch (error) {
      console.error("Error fetching queues:", error);
    }
  };

  const fetchholidayQueueslist = async () => {
    const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
    const region = localStorage.getItem("Region");
    const EncryptedInstanceId = localStorage.getItem("EncryptedId");

    const body = {
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region: region,
      InstanceAlias: instanceAlias,
      Email: email,
      UserName: username,
    };

    try {
      const [queueResponse, holidayResponse] = await Promise.all([
        axiosInstance.post(endpoints.queuesDisplay.viewQueues, body),
        axiosInstance.get(endpoints.globalEnable.holidayStatus),
      ]);

      if (queueResponse.data.statusCode === 200) {
        const queueData = JSON.parse(queueResponse.data.body);
        const holidayData = holidayResponse.data?.data || [];
        const holidayMap = {};
        holidayData.forEach((item) => {
          const key = item.Queue?.trim().toLowerCase().replace(/\s+/g, "");
          holidayMap[key] = item.HolidayStatus;
        });

        if (
          queueData.queues &&
          Array.isArray(queueData.queues.DescribedQueues)
        ) {
          const extractedData = queueData.queues.DescribedQueues.map((item) => {
            const quickConnectNames =
              item.QuickConnects && Array.isArray(item.QuickConnects)
                ? item.QuickConnects.map((qc) => qc.QuickConnectName).join(", ")
                : "No QuickConnects";

            const tags = item.Tags
              ? Object.entries(item.Tags)
                .map(([key, value]) => `${key}: ${value}`)
                .join(", ")
              : "No tags";
            const normalizedName = item.Name?.trim().toLowerCase().replace(/\s+/g, "");
            console.log("Queue:", item.Name, "Mapped Status:", holidayMap[normalizedName]);
            return {
              name: item.Name,
              description: item.Description || "No description",
              HoursOfOperationName:
                item.HoursOfOperationName || "No hours set",
              QuickConnectName: quickConnectNames,
              maxContacts: item.MaxContacts || "-",
              status: item.Status || "UNKNOWN",
              holidayStatus:
                holidayMap[normalizedName] !== undefined
                  ? holidayMap[normalizedName]
                  : false,
              tags,
              arn: item.QueueArn,
              timeZone: item.TimeZone || "No timezone",
              config: item.Config || {},
              lastModifiedTime:
                item.LastModifiedTime || "No modification time",
              outboundCallerIdName:
                item.OutboundCallerConfig?.OutboundCallerIdName || "-",
              outboundCallerIdNumber:
                item.OutboundCallerIdNumber || "-",
              outboundFlowName: item.OutboundFlowName || "-",
              quickConnectTypes: item.QuickConnects
                ? item.QuickConnects.map((qc) => qc.QuickConnectType)
                : ["No Quick Connects"],
            };

          });

          console.log("Final Data:", extractedData); // 🔍 debug

          setSelectedComponent("HolidayPage");
          setSelectedComponentData(extractedData);
        } else {
          console.warn("No DescribedQueues found in response");
        }
      } else {
        console.error("Failed to fetch queues:", queueResponse.data.message);
      }
    } catch (error) {
      console.error("Error fetching queues:", error);
    }
  };

  const fetchVoicemail = async () => {
    try {
      const response = await axiosInstance.post(
        endpoints.voiceMailsDisplay.voiceMailList,
        {
          Action: "Voicemail"
        }
      );

      const apiResponse = response.data;
      const parsedData = apiResponse.body
        ? JSON.parse(apiResponse.body)
        : [];

      console.log("Mailbox API Response:", parsedData);
      const formattedData = parsedData.map((item, index) => ({
        id: index + 1, // required for table key
        name: item.Name || "-",
        type:
          item.Type?.toLowerCase() === "queue"
            ? "Queue"
            : "Agent",
        created: item.Created || "-"
      }));

      setSelectedComponent("VoiceMailPage");
      setSelectedComponentData(formattedData);

    } catch (error) {
      console.error("Error loading voicemail UI:", error);
      setSelectedComponentData([]);
    }
  };

  const cardData = [
    {
      id: 1,
      icon: <PermPhoneMsgIcon />,
      label: "Phone Number",
      paragraph:
        "Claimed phone numbers of Amazon Connect and attach contact flows to phone numbers.",
      viewButtonText: "View Phone Numbers",
      fetchFunction: fetchPhoneNumbers,
      learnMoreLink: "https://docs.aws.amazon.com/connect/latest/adminguide/claim-phone-number.html"
    },
    {
      id: 2,
      icon: <WatchLaterIcon className="card-icon" />,
      label: "Hours Of Operation",
      paragraph:
        "Hours of operation define when Amazon Connect resources, such as queues, are available, and may be referenced in flows.",
      viewButtonText: "View Hours of Operation",
      fetchFunction: fetchHoursOfOperation,
      learnMoreLink:
        "https://docs.aws.amazon.com/connect/latest/adminguide/set-hours-operation.html"
    },
    {
      id: 3,
      icon: <QueueIcon className="card-icon" />,
      label: " Queues",
      paragraph:
        "Queues route contacts to the best agents. If you need to prioritize contacts or match them with specific skills, create multiple queues.",
      viewButtonText: "View Queues",
      fetchFunction: fetchQueues,
      learnMoreLink:
        "https://docs.aws.amazon.com/connect/latest/adminguide/create-queue.html"
    },
    {
      id: 4,
      icon: <QueueMusicIcon className="card-icon" />,
      label: "Prompts",
      paragraph:
        "Prompts are audio files for contact flows, either uploaded or recorded. Updates apply instantly to all related flows.",
      viewButtonText: "View Prompts",
      fetchFunction: fetchPrompts,
      learnMoreLink:
        "https://docs.aws.amazon.com/connect/latest/adminguide/prompts.html"
    },
    {
      id: 5,
      icon: <CallSplitIcon className="card-icon" />,
      label: " Routing Profile",
      paragraph:
        "A Routing Profile groups queues for agents, allowing them to handle multiple queues with set priorities.",
      viewButtonText: "View Routing Profiles",
      fetchFunction: fetchRoutingProfile,
      learnMoreLink:
        "https://docs.aws.amazon.com/connect/latest/adminguide/routing-profiles.html"
    },
    {
      id: 6,
      icon: <GroupIcon className="card-icon" />,
      label: "Configure Users",
      paragraph:
        "User Management allows you to add, manage, and delete users, as well as assign routing profiles and permissions.",
      viewButtonText: "View Users",
      fetchFunction: fetchUsers,
      learnMoreLink:
        "https://docs.aws.amazon.com/connect/latest/adminguide/manage-users.html"
    },
    {
      id: 7,
      icon: <AdminPanelSettingsIcon className="card-icon" />,
      label: "Security Profiles",
      paragraph:
        "A Security Profile defines a set of permissions that control what actions a user can perform within the system.",
      viewButtonText: "View Security Profiles",
      fetchFunction: fetchSecurityProfiles,
      learnMoreLink:
        "https://docs.aws.amazon.com/connect/latest/adminguide/connect-security-profiles.html"
    },
    {
      id: 8,
      icon: <AddLinkIcon />,
      label: "Quick Connect",
      paragraph:
        "Quick connects are a way for you to create a list of destinations for common transfers.",
      viewButtonText: "View Quick Connects",
      fetchFunction: fetchQuickConnects,
      learnMoreLink:
        "https://docs.aws.amazon.com/connect/latest/adminguide/quick-connects.html"
    },
    {
      id: 9,
      icon: <AddLinkIcon />,
      label: "Emergency Close",
      paragraph:
        "",
      viewButtonText: "View Emergency list",
      fetchFunction: fetchQueueslist,
      learnMoreLink:
        "https://docs.aws.amazon.com/connect/latest/adminguide/quick-connects.html"
    },
    {
      id: 10,
      icon: <AddLinkIcon />,
      label: "Holiday",
      paragraph:
        "",
      viewButtonText: "View list",
      fetchFunction: fetchholidayQueueslist,
      learnMoreLink:
        "https://docs.aws.amazon.com/connect/latest/adminguide/quick-connects.html"
    },
    {
      id: 11,
      icon: <AddLinkIcon />,
      label: "Voicemail",
      paragraph:
        "",
      viewButtonText: "View list",
      fetchFunction: fetchVoicemail,
      learnMoreLink:
        "https://docs.aws.amazon.com/connect/latest/adminguide/quick-connects.html"
    },
  ];

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const [open, setOpen] = useState(false);

  const handleToggle = (event) => {
    setOpen(event.target.checked);
  };

  // Updated handleCardClick function to properly manage active states
  const handleCardClick = async (card) => {
    setSelectedComponent(null);
    setSelectedComponentData(null);
    setSelectedCardId(card.id);
    setLoading(true);
    setLoadingButtonId(card.id);

    try {
      await card.fetchFunction();
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      setLoading(false);
      setLoadingButtonId(null);
    }
  };

  const handleActivityClick = async () => {
    setSelectedComponent(null);
    setSelectedComponentData(null);
    setSelectedCardId("activity");
    setLoading(true);
    try {
      await fetchLogs();
    } catch (error) {
      console.error("Error loading logs:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setShowProfileDetails(false);
  };

  const handleMyProfileClick = () => {
    setShowProfileDetails(true);
  };

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const formatDateTime = (date, time) => {
    if (!date || !time) return "";
    return new Date(`${date}T${time}:00Z`).toISOString();
  };

  const [queues, setQueues] = useState([]);
  const [selectedQueue, setSelectedQueue] = useState("");

  const handleSubmitEmergency = async () => {
    if (!selectedQueue || !startDate || !endDate || !startTime || !endTime) {
      alert("Please fill all fields");
      return;
    }
    const body = {
      Queue: selectedQueue,
      EmergencyStatus: open,
      StartDate: startDate,
      EndDate: endDate,
      StartTime: formatDateTime(startDate, startTime),
      EndTime: formatDateTime(endDate, endTime),
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region,
      InstanceAlias: instanceAlias,
    };

    try {
      const response = await axiosInstance.post(
        "https://tygfe6u5hj.execute-api.us-west-2.amazonaws.com/test1/EmergencyClose",
        body
      );

      if (response.data.statusCode === 200) {
        setOpen(false);
      }
    } catch (err) {
      console.error("Error submitting emergency close:", err);
    }
  };

  const handleLogOut = () => {
    localStorage.clear();
    navigate("/adminstrator-page");
  };

  const selectedCard = cardData.find((c) => c.id === selectedCardId) || cardData[0];

  return (
    <div className="connect-admin-container">
      <AppBar position="static">
        <Toolbar className="appbar-connectadmin-container">
          <img src={CCBAppBarLogo} alt="Logo" className="connect-navbar-logo" />
          <img src={CCBAppBarLogo} alt="Logo" className="small-screen-logo" />

          <div className="connect-profile-section">
            <AccountCircle
              className="user-logo-connect"
              onClick={handleProfileClick}
              style={{ cursor: "pointer" }}
            />
            <Typography
              variant="h6"
              className="connectnavbarstyle"
              onClick={handleProfileClick}
              style={{ cursor: "pointer" }}
            >
              {username}
            </Typography>
            <IconButton onClick={handleProfileClick} color="inherit">
              <ExpandMore className="connectnavexpandbtn" />
            </IconButton>

            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {showProfileDetails ? (
                <div className="profile-box">
                  <div className="field-group" style={{ display: 'flex', gap: '8px' }}>
                    <span className="field-label" style={{ fontWeight: 'bold' }}>Username:</span>
                    <span className="field-value" style={{ textAlign: 'left', flex: 1 }}>
                      {username}
                    </span>
                  </div>

                  <div className="field-group" style={{ display: 'flex', gap: '8px' }}>
                    <span className="field-label" style={{ fontWeight: 'bold' }}>Account ID:</span>
                    <span className="field-value" style={{ textAlign: 'left', flex: 1 }}>
                      {customerAWSAccountId}
                    </span>
                  </div>

                  <Button onClick={() => setShowProfileDetails(false)} className="profile-button">
                    Back
                  </Button>
                </div>
              ) : (
                <>
                  <MenuItem onClick={handleMyProfileClick} className="connectnavbarstyle">
                    My Profile
                  </MenuItem>
                  <MenuItem onClick={handleLogOut} className="connectnavbarstyle">
                    Logout
                  </MenuItem>
                </>
              )}
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      <Box sx={{ display: "flex", height: "calc(100vh - 64px)", overflow: "hidden" }}>
        {/* Fixed Sidebar with persistent active states */}
        <Box
          sx={{
            width: sidebarOpen ? 280 : 60,
            bgcolor: "#f5f5f5",
            borderRight: "1px solid #ccc",
            transition: "width 0.3s ease-in-out",
            flexShrink: 0,
            position: "fixed",
            top: "64px",
            left: 0,
            height: "calc(100vh - 64px)",
            display: "flex",
            flexDirection: "column",
            zIndex: 1000,
          }}
        >
          {/* Sidebar toggle */}
          <Box
            sx={{
              p: 1,
              borderBottom: "1px solid #e0e0e0",
              flexShrink: 0,
              bgcolor: "#f5f5f5"
            }}
          >
            <Box display="flex" justifyContent={sidebarOpen ? "space-between" : "center"} alignItems="center" sx={{ flexDirection: sidebarOpen ? "row" : "column", gap: 1 }}>
              {sidebarOpen ? (
                <Button
                  className="il-back-btn"
                  startIcon={<ArrowBack />}
                  onClick={() => navigate("/aws-AccountsList-page")}
                >
                  Back to Accounts
                </Button>
              ) : (
                <Tooltip title="Back to Accounts">
                  <IconButton
                    onClick={() => navigate("/aws-AccountsList-page")}
                    size="small"
                    sx={{
                      bgcolor: "white",
                      boxShadow: 1,
                      "&:hover": { bgcolor: "#f0f0f0" }
                    }}
                  >
                    <ArrowBack fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              {/* <Tooltip title={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}>
                <IconButton
                  onClick={toggleSidebar}
                  size="small"
                  sx={{
                    bgcolor: "white",
                    boxShadow: 1,
                    "&:hover": { bgcolor: "#f0f0f0" }
                  }}
                >
                  {sidebarOpen ? <ChevronLeft /> : <ChevronRight />}
                </IconButton>
              </Tooltip> */}
            </Box>
          </Box>

          <Divider />

          {/* Scrollable sidebar content with enhanced active states */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              overflowX: "hidden",
              p: 1,
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
                borderRadius: "3px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#c1c1c1",
                borderRadius: "3px",
                "&:hover": {
                  background: "#a1a1a1",
                },
              },
            }}
          >
            {/* Sidebar navigation list */}
            <List sx={{ p: 0 }}>
              {cardData.map((card) => {
                const isLoading = loadingButtonId === card.id;
                const isActive = selectedCardId === card.id;

                return (
                  <ListItem
                    button
                    key={card.id}
                    onClick={() => handleCardClick(card)}
                    sx={{
                      // Active state styling - this persists until another item is selected
                      bgcolor: isActive ? "#1976d2 !important" : "transparent",
                      color: isActive ? "white" : "inherit",

                      // Hover effects
                      "&:hover": {
                        bgcolor: isActive ? "#1565c0 !important" : "#e3f2fd !important"
                      },

                      // Focus state
                      "&:focus": {
                        bgcolor: isActive ? "#1976d2 !important" : "#e3f2fd !important"
                      },

                      // Layout and spacing
                      minHeight: 48,
                      px: sidebarOpen ? 2 : 1,
                      justifyContent: sidebarOpen ? "flex-start" : "center",
                      gap: 1,
                      borderRadius: 1,
                      mb: 0.5,

                      // Loading state
                      opacity: isLoading ? 0.7 : 1,
                      pointerEvents: isLoading ? "none" : "auto",

                      // Smooth transitions
                      transition: "all 0.2s ease-in-out",

                      // Active state border/shadow for extra emphasis
                      ...(isActive && {
                        boxShadow: "inset 3px 0 0 #fff",
                        fontWeight: "bold"
                      })
                    }}
                  >
                    {/* Loading indicator */}
                    {isLoading && (
                      <CircularProgress
                        size={12}
                        color={isActive ? "inherit" : "primary"}
                        sx={{ mr: sidebarOpen ? 1 : 0 }}
                      />
                    )}

                    {/* Active indicator icon (optional - shows when collapsed) */}
                    {!sidebarOpen && isActive && (
                      <Box
                        sx={{
                          width: 4,
                          height: 4,
                          bgcolor: "white",
                          borderRadius: "50%",
                          position: "absolute",
                          right: 8,
                          top: "50%",
                          transform: "translateY(-50%)"
                        }}
                      />
                    )}

                    {/* Text content */}
                    <ListItemText
                      primary={sidebarOpen ? card.label : ""}
                      sx={{
                        "& .MuiListItemText-primary": {
                          fontSize: "14px",
                          fontWeight: isActive ? "bold" : "normal",
                          color: "inherit"
                        }
                      }}
                    />
                  </ListItem>
                );
              })}
            </List>

            {/* Activity button at bottom of sidebar with persistent active state */}
            <Box sx={{ p: 1, mt: 2 }}>
              <Button
                variant={selectedCardId === "activity" ? "contained" : "outlined"}
                fullWidth={sidebarOpen}
                size={sidebarOpen ? "medium" : "small"}
                onClick={handleActivityClick}
                sx={{
                  fontSize: sidebarOpen ? "14px" : "12px",
                  minWidth: sidebarOpen ? "auto" : "40px",

                  // Active state styling that persists
                  bgcolor: selectedCardId === "activity" ? "#1976d2" : "transparent",
                  color: selectedCardId === "activity" ? "white" : "inherit",
                  borderColor: selectedCardId === "activity" ? "#1976d2" : "#ccc",

                  "&:hover": {
                    bgcolor: selectedCardId === "activity" ? "#1565c0" : "#e3f2fd",
                    borderColor: selectedCardId === "activity" ? "#1565c0" : "#1976d2"
                  },

                  // Transition for smooth state changes
                  transition: "all 0.2s ease-in-out"
                }}
              >
                {sidebarOpen ? "Activity" : "A"}
              </Button>
            </Box>
          </Box>
        </Box>
        {/* Main content area with proper offset and fade effect */}
        <Box
          sx={{
            flex: 1,
            marginLeft: sidebarOpen ? "280px" : "60px",
            transition: "margin-left 0.3s ease-in-out",
            height: "calc(100vh - 64px)",
            overflowY: "auto",
            p: 3,
            opacity: selectedComponent ? 1 : 0.9,
            transition: "opacity 0.2s ease-in-out"
          }}
        >
          {!selectedComponent && selectedCardId !== "activity" && (
            <>
              <Box display="flex" alignItems="center" mb={2}>
                <Box mr={2} className="circle-icon">{selectedCard.icon}</Box>
                <Typography variant="h5" fontWeight="bold">{selectedCard.label}</Typography>
              </Box>

              <Typography
                variant="body1"
                mb={3}
                sx={{
                  maxHeight: '120px',
                  overflowY: 'auto',
                  lineHeight: 1.5,
                  wordWrap: 'break-word',
                  fontFamily: "Montserrat !important",
                  pr: 1,
                  textAlign: "left",
                  pl: 8
                }}
              >
                {selectedCard.paragraph}
              </Typography>

              <Box display="flex" gap={2} mb={3}>
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#ACCEF7", fontSize: "12px" }}
                  onClick={() => window.open("https://docs.aws.amazon.com/connect", "_blank")}
                >
                  Learn More
                </Button>

                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: loadingButtonId === selectedCard.id ? "#ccc" : "#0d4ccd",
                    fontSize: "12px"
                  }}
                  disabled={loadingButtonId === selectedCard.id}
                  onClick={() => handleCardClick(selectedCard)}
                >
                  {loadingButtonId === selectedCard.id ? (
                    <CircularProgress size={18} color="inherit" />
                  ) : (
                    selectedCard.viewButtonText
                  )}
                </Button>
              </Box>
            </>
          )}
          {/* Component rendering with fade-in effect */}
          {loading && selectedCardId === "activity" && (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <CircularProgress />
            </Box>
          )}
          <Box sx={{
            opacity: selectedComponent ? 1 : 0,
            transition: "opacity 0.3s ease-in-out"
          }}>


            {/* Your existing selectedComponent rendering block goes here */}
            {!loading && selectedComponent === "PhoneNumberPage" && <PhoneNumberPage data={selectedComponentData} />}
            {!loading && selectedComponent === "QuickConnectPage" && <QuickConnectPage data={selectedComponentData} />}
            {!loading && selectedComponent === "SecurityProfilesPage" && <SecurityProfilesPage data={selectedComponentData} />}
            {!loading && selectedComponent === "HoursOperationPage" && <HoursOperationPage data={selectedComponentData} />}
            {!loading && selectedComponent === "QueuesPage" && <QueuesPage data={selectedComponentData} />}
            {!loading && selectedComponent === "RoutingPage" && <RoutingProfielPage data={selectedComponentData} />}
            {!loading && selectedComponent === "LogsPage" && <LogsPage data={selectedComponentData} />}
            {!loading && selectedComponent === "PromptsPage" && <PromptsPage prompts={selectedComponentData} />}
            {!loading && selectedComponent === "UserPage" && <UserPage users={selectedComponentData} />}
            {!loading && selectedComponent === "EmergencyPage" && <EmergencyPage emergency={selectedComponentData} />}
            {!loading && selectedComponent === "HolidayPage" && <HolidayPage holiday={selectedComponentData} />}
            {!loading && selectedComponent === "VoiceMailPage" && <VoicemailPage voicemail={selectedComponentData} />}

          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default ConnectPage